export default {
  general: 'Allgemein',
  materialCalculationModels: 'Werkstoffberechnungsmodelle',
  quenchingMediaSettings: 'Abschreckmedium',
};
